"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover = _interopRequireDefault(require("reactstrap/lib/Popover"));

var _UncontrolledPopover = _interopRequireDefault(require("reactstrap/lib/UncontrolledPopover"));

var _PopoverHeader = _interopRequireDefault(require("reactstrap/lib/PopoverHeader"));

var _PopoverBody = _interopRequireDefault(require("reactstrap/lib/PopoverBody"));

var _utils = require("../lib/utils");

require("./popover.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

var Popover = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Popover, _React$PureComponent);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentClick", function (e) {
      var _this$props = _this.props,
          hideOnOutsideClick = _this$props.hideOnOutsideClick,
          toggle = _this$props.toggle;

      if (hideOnOutsideClick && (0, _utils.isFunction)(toggle) && _this.innerRef.current && !isInDOMSubtree(e.target, _this.innerRef.current)) {
        toggle(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopoverContent", function () {
      var _this$props2 = _this.props,
          title = _this$props2.title,
          body = _this$props2.body,
          bodyClassName = _this$props2.bodyClassName;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react["default"].Fragment, null, title && /*#__PURE__*/_react["default"].createElement(_PopoverHeader["default"], null, title), body && /*#__PURE__*/_react["default"].createElement(_PopoverBody["default"], {
          className: bodyClassName
        }, (0, _utils.isFunction)(body) ? body() : body))
      );
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function () {
      var _this$props3 = _this.props,
          size = _this$props3.size,
          disabled = _this$props3.disabled,
          placement = _this$props3.placement,
          hideArrow = _this$props3.hideArrow,
          type = _this$props3.type,
          isOpen = _this$props3.isOpen,
          toggle = _this$props3.toggle,
          trigger = _this$props3.trigger;
      var target = _this.state.target;
      var commonProps = {
        popperClassName: (0, _utils.gatherClasses)(_this.props, "oui-popover oui-popover-".concat(size)),
        delay: 0,
        disabled: disabled,
        placement: placement,
        placementPrefix: "oui-bs-popover",
        target: target,
        hideArrow: hideArrow,
        fade: false
      };

      if (target) {
        if (type === "controlled") {
          return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({}, commonProps, {
            innerRef: _this.innerRef,
            boundariesElement: "window",
            isOpen: isOpen,
            toggle: toggle,
            trigger: trigger
          }), _this.renderPopoverContent());
        }

        return /*#__PURE__*/_react["default"].createElement(_UncontrolledPopover["default"], (0, _extends2["default"])({}, commonProps, {
          boundariesElement: "window",
          trigger: trigger === "click" ? "legacy" : trigger
        }), _this.renderPopoverContent());
      }

      return null;
    });
    _this.state = {
      target: null
    };
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.innerRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.bindTarget();
      document.addEventListener("click", this.handleDocumentClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleDocumentClick);
    }
  }, {
    key: "bindTarget",
    value: function bindTarget() {
      // eslint-disable-next-line react/no-find-dom-node
      var target = _reactDom["default"].findDOMNode(this.ref.current);

      if (target instanceof HTMLElement || target instanceof SVGElement) {
        this.setState({
          target: target
        });
      } else {
        // eslint-disable-next-line no-console
        console.error("Could not find target for the popover component.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react["default"].Fragment, null, this.renderPopover(), /*#__PURE__*/_react["default"].createElement(PopoverWrapper, {
          ref: this.ref
        }, children))
      );
    }
  }]);
  return Popover;
}(_react["default"].PureComponent);

Popover.propTypes = {
  title: _propTypes["default"].string,
  body: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]).isRequired,
  type: _propTypes["default"].oneOf(["controlled", "uncontrolled"]),
  isOpen: (0, _utils.requiredIf)(_propTypes["default"].bool, function (props) {
    return props.type === "controlled";
  }),
  toggle: (0, _utils.requiredIf)(_propTypes["default"].func, function (props) {
    return props.type === "controlled";
  }),
  placement: _propTypes["default"].oneOf(["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "right", "right-start", "right-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end"]),
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg", "auto"]),
  bodyClassName: _propTypes["default"].string,
  className: _propTypes["default"].string,
  hideArrow: _propTypes["default"].bool,
  hideOnOutsideClick: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  trigger: _propTypes["default"].string
};
Popover.defaultProps = {
  placement: "auto",
  disabled: false,
  type: "controlled",
  size: "sm",
  hideArrow: false,
  hideOnOutsideClick: false,
  trigger: "click"
};
Popover.displayName = "OrionPopover";
var _default = Popover;
/**
 * PopoverWrapper will help binding ref on the Popover children component
 * As that ref is further used to pass the target element to Popover component
 */
// eslint-disable-next-line react/prefer-stateless-function

exports["default"] = _default;

var PopoverWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PopoverWrapper, _React$Component);

  var _super2 = _createSuper(PopoverWrapper);

  function PopoverWrapper() {
    (0, _classCallCheck2["default"])(this, PopoverWrapper);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(PopoverWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children; // eslint-disable-next-line react/jsx-fragments

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
    }
  }]);
  return PopoverWrapper;
}(_react["default"].Component);

PopoverWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};